import React from "react";
import { Card } from "@campgladiator/cgui-core.atoms.card";
import { ItemProps } from "@campgladiator/cgui-core.molecules.list-menu";
import {
  ProgramScheduleDTO,
  TrainerProgramApproval,
} from "@campgladiator/cg-common.types.types";
import styles from "./SelectTrainer.module.scss";
import { ProductHeading } from "../ProductHeading";
import { UpgradeMembershipModalProps } from "../../UpgradeMembershipModal";
import { SelectedProductOption } from "../SelectProduct";
import {
  SelectTrainerInput,
  SelectTrainerInputProps,
} from "../../../SelectTrainerInput";

export type SelectedTrainer = ItemProps & {
  programSchedules: ProgramScheduleDTO[];
};

export type SelectTrainerProps = {
  approvedProgram: TrainerProgramApproval[];
  onClearTrainerSearch: () => void;
  onItemSelect: (id: SelectedTrainer) => void;
  selectedProductOption: SelectedProductOption;
  selectedTrainer?: SelectedTrainer;
  setIsTrainerLoading: (isLoading: boolean) => void;
  setTrainerProgramSchedules: (programSchedules: ProgramScheduleDTO[]) => void;
} & Pick<UpgradeMembershipModalProps, "productName" | "productPrice">;

const SelectTrainer = ({
  approvedProgram,
  onClearTrainerSearch,
  onItemSelect,
  productName,
  productPrice,
  selectedProductOption,
  selectedTrainer,
  setIsTrainerLoading,
  setTrainerProgramSchedules,
}: SelectTrainerProps) => {
  const selectTrainerInputProps: SelectTrainerInputProps = {
    approvedProgram,
    onClearTrainerSearch,
    onItemSelect,
    selectedProductSubType: selectedProductOption?.productDetails?.subType,
    selectedProductType: selectedProductOption?.productDetails?.type,
    selectedTrainer,
    setIsTrainerLoading,
    setTrainerProgramSchedules,
  };

  return (
    <>
      <ProductHeading productName={productName} productPrice={productPrice} />
      <div className={styles.selectTrainer}>
        <Card flat className={styles.selectTrainerCard}>
          <SelectTrainerInput {...selectTrainerInputProps} />
        </Card>
      </div>
    </>
  );
};

export default SelectTrainer;
